import { render } from "./ExamenCortoView.vue?vue&type=template&id=5446bc4d&ts=true"
import script from "./ExamenCortoView.vue?vue&type=script&lang=ts"
export * from "./ExamenCortoView.vue?vue&type=script&lang=ts"

import "./ExamenCortoView.vue?vue&type=style&index=0&id=5446bc4d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__